var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"singularity-panel vscroll-wrap vscroll-scroll"},[_c('div',{staticClass:"c__wrapper"},[_c('SingularityPanelHeader',{attrs:{"parentTitle":"Settings"}}),_vm._m(0)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"singularity-panel__content"},[_c('p',[_vm._v("Business name, description, modifiers")])])
}]

export { render, staticRenderFns }